@if (!!data) {
  <h2 mat-dialog-title class="primary">
    <div class="profile-box">
      @if (reporter) {
        <img class="profile-image" src="/assets/images/profile-dialog-reporter.png" />
      }
      @if (!reporter) {
        <img class="profile-image" src="/assets/images/profile-dialog-streapper.png" />
      }
      <img class="profile-photo" [src]="getProfilePicture()" />
      <button class="close-ref" mat-icon-button mat-dialog-close [title]="'general.close' | translate | titlecase">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </h2>
  <div class="profile-content" mat-dialog-content>
    @if (data.createdBy) {
      <div>
        <div> {{ 'profile-dialog.name' | translate }}  {{ name }}</div>
        <div> {{ 'profile-dialog.amount-streapps' | translate }}  {{ amount }}</div>
      </div>
    }
    @if (!data.createdBy) {
      <div>
        {{ 'profile-dialog.anonymous' | translate }}
      </div>
    }
  </div>
}
